export const infoCardsWrapper = {
  background: "#12141D",
  padding: "5.625rem 9.5rem",
};
